import { getImageUrl } from '../utils/imageLoading';
import { PaymentMethod } from './enums';

const donationDefaultAmounts = [25, 50, 100];

function setPartnerLogoUrl(action) {
    if (action.partner == null || action.partner.logoId == null) return action;

    return {
        ...action,
        partner: {
            ...action.partner,
            logoUrl: `${getImageUrl(action.partner.logoId)}`
        }
    };
}

function processDonation(action) {
    return {
        ...action,
        partner: {
            ...action.partner,
            paymentMethod:
                action.partner.paymentType === 'NoDirectPayment'
                    ? PaymentMethod.PandaPay
                    : action.partner.paymentType
        },
        amounts:
            action.oneCardCustomAmounts != null && action.oneCardCustomAmounts.length
                ? action.oneCardCustomAmounts
                : donationDefaultAmounts
    };
}

export default function processDataaaa(data) {
    const actions = data.actions.map(a => {
        let action = {
            ...a,
            identifier: `${a.id}|${a.type}`,
            type: a.type.toLowerCase(),
            recipientPictureId: a.recipientPictureId || a.pictureId // condensing 2 keys into one
        };

        if (action.type === 'donation') {
            action = processDonation(action);
        }

        action = setPartnerLogoUrl(action);
        return action;
    });
    const cards = data.cards.map(c => setPartnerLogoUrl(c));
    const pictures = actions
        .filter(action => !!action.recipientPictureId)
        .concat(data.cards.filter(card => !!card.recipientPictureId))
        .map(obj => obj.recipientPictureId)
        .concat(actions.filter(a => !!a.endCardPictureId).map(a => a.endCardPictureId))
        .map(recipientPictureId => ({
            recipientPictureId,
            pictureUrl: `${getImageUrl(recipientPictureId)}`
        }));
    return {
        ...data,
        actions,
        cards,
        pictures,
        publisherLogoUrl: getImageUrl(data.publisherLogoName)
    };
}
